import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const FeatureCard = ({ dashboardData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

const logData = [
  {
    label: t("dashboard.todayLogs"),
    value: dashboardData?.todayLogs || 0,
  },
  {
    label: t("dashboard.last7DaysLogs"),
    value: dashboardData?.last7DaysLogs || 0,
  },
  {
    label: t("dashboard.failedLogsToday"),
    value: dashboardData?.failedLogsToday || 0,
  },
];

  return (
    <>
      <Row>
        {logData &&
          logData.length > 0 &&
          logData?.map((item, key) => (
            <Col
              key={key}
              lg="3"
              md="4"
              sm="6"
              className="my-2"
              onClick={() => navigate(item.redirectPath)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="cardCstm rounded p-3 py-lg-4 d-flex align-items-center justify-content-center gap-10"
                style={{
                  background: "#e8307a21",
                  borderRadius: "5px",
                }}
              >
                <div className="content text-center">
                  <h6
                    className="m-0 fw-bold py-1 text-dark"
                    style={{ fontSize: "14px" }}
                  >
                    {item.label}
                  </h6>
                  <h4 className="m-0 fw-bold themeBlue py-1">{item.value}</h4>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default FeatureCard;
